import React from "react";
import getIconFromName from "@/utils/functions/getIconfromName";
import { ProcessedCourse } from "@/common/course/types";
import {
  getProgramBadgeInformation,
  getCourseBadgeInformation,
} from "./badgeUtils";
import { UseLeadWithPaidResult } from "@/monarch/rules/leadWithPaid/types";
import useTranslations from "@/i18n/useTranslations";

interface DynamicBadgesProps {
  courseData: ProcessedCourse | ProcessedCourse[];
  styles: { badge: string; badgeText: string; margin?: string };
  leadWithPaidData?: UseLeadWithPaidResult;
  insertBadges?: { header: string; icon: string }[];
  children?: React.ReactNode;
}

function DynamicBadges({
  courseData,
  styles,
  leadWithPaidData,
  insertBadges,
  children,
}: DynamicBadgesProps) {
  const tCourse = useTranslations("Course");
  let combinedBadgeInformation = [];
  if (insertBadges && insertBadges.length > 0) {
    combinedBadgeInformation = insertBadges;
  } else {
    const isMultipleCourses = Array.isArray(courseData);
    let badgeInformation = [];
    if (isMultipleCourses) {
      badgeInformation = getProgramBadgeInformation(courseData, tCourse);
    } else {
      badgeInformation = getCourseBadgeInformation(courseData, tCourse);
    }
    const leadWithPaidTest = leadWithPaidData?.value;
    const overview = leadWithPaidTest?.overview ?? {};

    // Add monarch data if available
    const monarchBadges = Object.values(overview).map((overviewItem) => ({
      header: overviewItem.overviewHeader,
      icon: overviewItem.overviewIcon,
    }));
    combinedBadgeInformation = [...badgeInformation, ...monarchBadges];
  }

  if (combinedBadgeInformation.length === 0) {
    return null;
  }

  return (
    <div
      className={`${styles.margin || ""} flex w-full flex-row flex-wrap gap-4 my-4 md:my-6 items-start`}
    >
      {combinedBadgeInformation.map((badge) => (
        <div
          key={badge.header}
          className={`inline-flex items-center gap-1 rounded border-[1.5px] py-1 px-2 ${styles.badge} ${styles.badgeText}`}
        >
          {getIconFromName(badge.icon, "14")}
          <span className={`text-xs font-bold ${styles.badgeText}`}>
            {badge.header}
          </span>
        </div>
      ))}
      {children}
    </div>
  );
}

export default DynamicBadges;
